import NativeCallbacks from './Callbacks';

class Native {
  constructor() {
    this.isMobile = false;
    this.exitGame = function() {
      console.log('Closing game');
    };
    this.isTablet = function() {
      return true;
    };
    this.isSoundEnabled = function() {
      return true;
    };
    this.doesMediaPlaybackRequireUserGesture = function() {
      return false;
    };

    this.getVolume = function() {
      NativeCallbacks.fireCallback(this.CB_SPEAKER_VOLUME_RETRIEVED, {
        volume: 1.0
      });
      return 1.0;
    };
    this.CB_SPEAKER_VOLUME_RETRIEVED = 'speaker_volume_retrieved';
    window.isIos = window.webkit && window.webkit.messageHandlers;
    if (window.Android) {
      this.isMobile = true;
      this.exitGame = function() {
        window.Android.exitGame();
      };
      this.isTablet = function() {
        return window.Android.isTablet();
      };
      this.isSoundEnabled = function() {
        return window.Android.isSoundEnabled();
      };
      this.doesMediaPlaybackRequireUserGesture = function() {
        return window.Android.doesMediaPlaybackRequireUserGesture();
      };
      this.getVolume = function() {
        return window.Android.requestVolume();
      };
    } else if (window.isIos) {
      this.isMobile = true;
      this.exitGame = function() {
        window.webkit.messageHandlers.exitGame.postMessage({});
      };
      this.isTablet = function() {
        return window.IOS_SETTINGS_MAP.IsTabletStorageKey;
      };
      this.isSoundEnabled = function() {
        return window.IOS_SETTINGS_MAP.IsSoundEnabledStorageKey;
      };
      this.playSound = function(sound) {
        window.webkit.messageHandlers.playSound.postMessage({
          sound
        });
      };
      this.getVolume = function() {
        window.webkit.messageHandlers.getVolume.postMessage({});
      };
    }
    return this;
  }

  setUpVolumeMessage(callback) {
    NativeCallbacks.setCallback(
      this.CB_SPEAKER_VOLUME_RETRIEVED,
      callback,
      false
    );
  }
}
const native = new Native();
export { native as default };
